import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { dateTime } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { PlugsConnected, CheckCircle, XCircle } from "@phosphor-icons/react";

function Light({ name, r, testid }) {
  const ok = r?.ok;
  return (
    <div data-testid={testid} className={`flex items-center gap-2 rounded-sm border px-3 py-2 text-sm ${r ? (ok ? "border-[hsl(var(--success))]/40 bg-[hsl(var(--success))]/10" : "border-destructive/40 bg-destructive/10") : "border-border bg-muted"}`}>
      {r ? (ok ? <CheckCircle size={16} weight="fill" className="text-[hsl(var(--success))]" /> : <XCircle size={16} weight="fill" className="text-destructive" />)
        : <span className="h-2.5 w-2.5 rounded-full bg-muted-foreground/40" />}
      <span className="font-mono">{name}</span>
      <span className="text-xs text-muted-foreground">{r ? r.detail : "not checked"}</span>
    </div>
  );
}

export const ConnectionCheck = () => {
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { const r = await api.get("/admin/votel/connection-check"); setRes(r.data); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-sm border border-border bg-card p-5" data-testid="votel-connection-card">
      <div className="mb-3 flex items-center justify-between">
        <div>
          <h3 className="font-heading font-semibold">Votel connection check</h3>
          <p className="text-xs text-muted-foreground">Read-only ping with the master key {res && `· checked ${dateTime(res.checked_at)}`}</p>
        </div>
        <Button size="sm" variant="outline" className="gap-1.5" onClick={run} disabled={busy} data-testid="votel-connection-check-btn">
          <PlugsConnected size={15} /> {busy ? "Checking…" : "Check connection"}
        </Button>
      </div>
      <div className="flex flex-wrap gap-2">
        <Light name="/leads" r={res?.leads} testid="conn-leads" />
        <Light name="/billing/transactions" r={res?.transactions} testid="conn-transactions" />
      </div>
    </div>
  );
};
